/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { DETAIL_DATA, ownership, timeline } from "./test-data/product.detail";

import { GET_ASSET_DETAIL } from "../pages/Collectibles/graphql/getasset-detail.query";
import moment from "moment";
import {
    LOGIN_MODAL_OPEN,
    LOGIN_MODAL_CLOSE,
    LOGIN_SUCCESS,
} from "../widgets/LoginModalVW";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";

const is = require("is_js");

const SERVICE_NAME = "AssetService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class AssetDetailService {
    private static instance: AssetDetailService;
    private vapp: VApplication;
    private eventbus: any;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.eventbus = EventBusModule?.getInstance()?.getEventBus();
    }
    public static getInstance(props: any = {}): AssetDetailService {
        if (!AssetDetailService.instance) {
            AssetDetailService.instance = new AssetDetailService(props);
        }
        return AssetDetailService.instance;
    }

    _findPrice(price: any[]) {
        let _price =
            is.array(price) &&
            price.map((item) => {
                return {
                    price: `${item?.amount} ${item?.currency}`,
                };
            });

        return _price;
    }

    async getAssetLockState(assetId: string) {
        log.blue(SERVICE_NAME, "Asset ID", assetId);
        return false;
    }

    async getAssetDetail(assetId: string) {
        // const graphqlModule = getGraphQLModule();
        // const client = graphqlModule.getClient("api-gateway");
        // try {
        //     if (client) {
        //         const res = await client.query({
        //             query: GET_ASSET_DETAIL,
        //             variables: {
        //                 tokenId:assetId,
        //                 storeId:"61739cbd2fbe0a187c984fb6"
        //             },
        //         });
        //         if(res){
        //             let _data = res?.data?.getAsset
        //             let _found ={
        //                 idx: _data?.idx,
        //                 title: _data?.title,
        //                 subtitle: _data?.subtitle,
        //                 serialNo: _data?.serialNo,
        //                 tag: 'GOLD',
        //                 category: 'gold',
        //                 price: _data?.price?.map((item:any)=>{
        //                     return({
        //                         ...item,
        //                         locale: 'en-US',
        //                         amount:parseInt(item?.amount?.slice(1, item?.amount?.length))
        //                     })
        //                 }),
        //                 meta: _data?.attrs?.map((item:any)=>{
        //                     return({
        //                         key:item?.name,
        //                         value: item?.val,
        //                         disp_type:item?.disp_type
        //                     })
        //                 }),
        //                 buttons: [
        //                     {
        //                         key: "buyNowFiat",
        //                         title: "Buy in USD"
        //                     },
        //                     {
        //                         key: "buyNowCrypto",
        //                         title: "Buy in ETH"
        //                     }
        //                 ],
        //                 images: _data?.media?.map((item:any)=>{
        //                     return({
        //                         original:item?.src,
        //                         thumbnail:item?.thumbnail,
        //                         thumbnailHeight: "70",
        //                         thumbnailClass:"image-thumb"
        //                     })
        //                 }),
        //                 timeline: _data?.timeline?.map((item:any)=>{
        //                     return({
        //                         title: `Asset ${item?.event}ed`,
        //                         description:[
        //                             // {
        //                             //     displayType: "date",
        //                             //     key: "Listed At",
        //                             //     value: item?.date?.toISOString()
        //                             // },
        //                             {
        //                                 displayType: "link",
        //                                 key: "From",
        //                                 value: item?.from?.value,
        //                                 link: item?.from?.link
        //                             },
        //                             {
        //                                 displayType: "link",
        //                                 key: "To",
        //                                 value: item?.to?.value,
        //                                 link: item?.to?.link
        //                             },
        //                             {
        //                                 displayType: "link",
        //                                 key: "Proof of List",
        //                                 value: item?.proof?.value,
        //                                 link: item?.proof?.link
        //                             }
        //                         ]
        //                     })
        //                 }),
        //             }
        //         if(_found){
        //             return _found;
        //         }
        //         }
        //     }
        // } catch (err) {
        //     return err;
        // }
        const _found = _.find(DETAIL_DATA, {
            idx: assetId,
        });
        let _nftsm = _found?.nftProvenance?.map((item) => {
            return {
                data: [
                    {
                        tag: item?.profile?.userId,
                        title: item?.title,
                        subtitle: item?.profile?.userName,
                        link: item?.profile?.link,
                        price: this._findPrice(item?.meta?.price),
                        date: moment.utc(1634876074000).format("lll"),
                    },
                ],
            };
        });
        return {
            ..._found,
            chainId: 4,
            colData: [
                {
                    title: "Event",
                },
                {
                    title: "Price",
                },
                {
                    title: "From",
                },
                {
                    title: "To",
                },
                {
                    title: "Date",
                },
            ],
            nftSMProvenance: _nftsm,
            // ownership:ownership,
            // timeline:timeline,
        };
    }

    async openUserLogin() {
        return this.eventbus?.emit(LOGIN_MODAL_OPEN, null, {});
    }

    async initiateClaim(assetId: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            return true;
            // if (client) {
            //     const res = await client.mutate({
            //         mutation: INITIATE_CLAIM,
            //         variables: {
            //             tokenId: assetId,
            //         },
            //     });
            //     log.success(SERVICE_NAME, "claim asset result: ", res);
            //     // return res?.data?.getAssets;
            //     return {};
            // }
        } catch (err) {
            log.error(SERVICE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return err;
        }
    }
}
